import { PencilIcon } from "@heroicons/react/24/outline";
import classNames from "../../../../utils/classNames";
import PriceFormat from "../../../../utils/priceFormat";
import CurrencyInput from "./CurrencyInput";

export default function EditablePartRow({
  label,
  value,
  isEditing,
  inputValue,
  onInputChange,
  onStartEdit,
  onSave,
  onCancel,
}: {
  label: string;
  value: number | undefined;
  isEditing: boolean;
  inputValue: string;
  onInputChange: (value: string) => void;
  onStartEdit: () => void;
  onSave: () => void;
  onCancel: () => void;
}) {
  return (
    <div className="flex items-center justify-between gap-2 px-3 py-1.5">
      <span className="flex-1 text-xs text-gray-700">{label}</span>

      {isEditing ? (
        <CurrencyInput
          value={inputValue}
          onChange={onInputChange}
          onSave={onSave}
          onCancel={onCancel}
          inputClassName="w-20 rounded border border-green-300 px-1.5 py-0.5 text-xs font-medium text-gray-900 focus:border-green-500 focus:ring-green-500"
          saveIconClassName="h-3 w-3"
        />
      ) : (
        <button
          type="button"
          onClick={onStartEdit}
          className={classNames(
            "flex items-center gap-1 rounded px-1.5 py-0.5 text-xs font-medium transition-colors",
            value != null
              ? "bg-green-100 text-green-700 hover:bg-green-200"
              : "text-gray-400 underline decoration-dashed underline-offset-2 hover:bg-gray-100 hover:text-primary-600"
          )}
        >
          {value != null ? PriceFormat(value) : "Add price"}
          <PencilIcon className="h-2.5 w-2.5" />
        </button>
      )}
    </div>
  );
}
